import { toSeconds } from 'duration-fns';
const getFastestProviders = (quotes) => {
    // sort quotes by max in deliveryEstimation.duration on where the smallest max first
    // then take the first one, and if there are more that are equal to the first one, also take them
    const sortedQuotes = quotes
        .filter((quote) => { var _a, _b; return (_b = (_a = quote === null || quote === void 0 ? void 0 : quote.deliveryEstimation) === null || _a === void 0 ? void 0 : _a.duration) === null || _b === void 0 ? void 0 : _b.max; })
        .sort((a, b) => {
        var _a, _b, _c;
        return toSeconds(((_a = a.deliveryEstimation.duration) === null || _a === void 0 ? void 0 : _a.max) || 0) -
            toSeconds(((_c = (_b = b.deliveryEstimation) === null || _b === void 0 ? void 0 : _b.duration) === null || _c === void 0 ? void 0 : _c.max) || 0);
    });
    const fastestProviders = sortedQuotes.filter((quote) => {
        var _a, _b, _c;
        return sortedQuotes.length > 0 &&
            ((_a = quote.deliveryEstimation.duration) === null || _a === void 0 ? void 0 : _a.max) &&
            ((_b = sortedQuotes[0].deliveryEstimation.duration) === null || _b === void 0 ? void 0 : _b.max) &&
            toSeconds((_c = quote.deliveryEstimation.duration) === null || _c === void 0 ? void 0 : _c.max) ===
                toSeconds(sortedQuotes[0].deliveryEstimation.duration.max);
    });
    return fastestProviders.map((quote) => quote.provider.alias);
};
export default getFastestProviders;
